export const PROJECT_REVIEW_COMPARE_MODE = {
  SINCE_PREVIOUS_REVIEW: 'SINCE_PREVIOUS_REVIEW',
  CUSTOM_PERIOD: 'CUSTOM_PERIOD',
} as const;
